import { useState } from 'react';
import styled from 'styled-components';

import { Flex } from '../../../../GlobalComponents/Flex';

type TabBarProps = {
	handleCardChange: (status: string) => void;
};

export const TabBar: React.FC<TabBarProps> = ({ handleCardChange }) => {
	const [state, setState] = useState('PRIMARY');
	const toggle = (status: string) => {
		setState(status);
		handleCardChange(status);
	};

	return (
		<Container>
			<Flex $flexDirection="row" $width="100vw">
				<Tab
					onClick={() => toggle('PRIMARY')}
					$isActive={state === 'PRIMARY'}
				>
					<TabText>Primary Card</TabText>
				</Tab>
				<Tab
					onClick={() => toggle('OTHER')}
					$isActive={state === 'OTHER'}
				>
					<TabText>All Cards</TabText>
				</Tab>
			</Flex>
		</Container>
	);
};

const Container = styled.div`
	box-shadow: 0 -36px rgba(245, 242, 242, 1);
	background-color: rgba(245, 242, 242, 1);
	margin: 0 -16px 0 -16px;
	display: flex;
	align-items: center;
	border-bottom: 1px #000000 solid;
	flex-direction: column;
	place-content: flex-start center;
	align-items: flex-start;
`;

const Tab = styled.div<TabProps>`
	background-color: ${props => (props.$isActive ? '#f47920' : '#f5f2f2')};
	border-radius: 4px 4px 0px 0px;
	padding: 12px;
	place-content: center;
	align-items: center;
	display: flex;
	width: 50%;
	color: ${props => (props.$isActive ? '#fff' : '#000000')};
`;
const TabText = styled.div`
	font-size: 16px;
	font-weight: 700;
	text-align: center;
`;

interface TabProps {
	$isActive: boolean;
}
